import { apiClient, unwrapApi } from './http';

/**
 * Auth API — JWT is httpOnly cookie only; session comes from GET /auth/me.
 */
export async function login(email, password) {
  const { data } = await apiClient.post('/auth/login', { email, password });
  return unwrapApi(data);
}

export async function logout() {
  await apiClient.post('/auth/logout');
}

export async function refresh() {
  const { data } = await apiClient.post('/auth/refresh');
  return unwrapApi(data);
}

export async function getMe() {
  const { data } = await apiClient.get('/auth/me');
  return unwrapApi(data);
}

export async function updateProfile(profileData) {
  const { data } = await apiClient.put('/auth/profile', profileData);
  return unwrapApi(data);
}

export async function changePassword(currentPassword, newPassword) {
  const { data } = await apiClient.put('/auth/change-password', {
    currentPassword,
    newPassword,
  });
  return unwrapApi(data);
}

export async function forgotPassword(email) {
  const { data } = await apiClient.post('/auth/forgot-password', { email });
  return unwrapApi(data);
}

export async function resetPassword(token, newPassword) {
  const { data } = await apiClient.post('/auth/reset-password', { token, newPassword });
  return unwrapApi(data);
}

export async function register(userData) {
  const { data } = await apiClient.post('/auth/register', userData);
  return unwrapApi(data);
}

const authService = {
  login,
  logout,
  refresh,
  getMe,
  updateProfile,
  changePassword,
  forgotPassword,
  resetPassword,
  register,
};

export default authService;
